/** Mention entity type from the API (e.g. skill, prompt, integration, workflow). */
export type MentionSearchType = string;

/** Query param value for GET /mentions/search → `types=skill,prompt` */
export const MENTION_SEARCH_TYPES_PARAM = ['skill', 'prompt'] as const;

export interface IMentionsSearchParams {
  q?: string;
  types?: MentionSearchType[];
  surface?: string;
  limit?: number;
}

/** Raw mention row from GET /mentions/search */
export type MentionSearchApiItem = {
  type: string;
  id: string;
  name: string;
  description?: string | null;
  iconUrl?: string | null;
};

export type MentionsSearchApiResponse =
  | MentionSearchApiItem[]
  | {
      success?: boolean;
      message?: string;
      data?: unknown;
      items?: unknown[];
      results?: unknown[];
    };
